import React from "react";

export default function ErrorAlert(props) {
  return (
    <div className="alert alert-danger w-100" role="alert">
      {props.errorMsg}
    </div>
  );
}
